export default __webpack_public_path__ + "static/media/tab-content-image-05.94175593.jpg";